(function() { window.GUID_27d9a9fc_1015_4762_8d24_f2bc2c1fb881 = { getGuid: function() { return "27d9a9fc-1015-4762-8d24-f2bc2c1fb881"; } }; })();
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Enter"] = 13] = "Enter";
    KeyCode[KeyCode["Escape"] = 27] = "Escape";
    KeyCode[KeyCode["SpaceBar"] = 32] = "SpaceBar";
    KeyCode[KeyCode["ArrowUp"] = 38] = "ArrowUp";
    KeyCode[KeyCode["ArrowDown"] = 40] = "ArrowDown";
    KeyCode[KeyCode["ArrowLeft"] = 37] = "ArrowLeft";
    KeyCode[KeyCode["ArrowRight"] = 39] = "ArrowRight";
    KeyCode[KeyCode["Add"] = 107] = "Add";
    KeyCode[KeyCode["Plus"] = 107] = "Plus";
    KeyCode[KeyCode["Subtract"] = 109] = "Subtract";
    KeyCode[KeyCode["Minus"] = 109] = "Minus";
})(KeyCode || (KeyCode = {}));

//# sourceMappingURL=KeycodeEnum.js.map
